import { render, staticRenderFns } from "./ListEvents.vue?vue&type=template&id=e8b2658c&"
import script from "./ListEvents.vue?vue&type=script&lang=js&"
export * from "./ListEvents.vue?vue&type=script&lang=js&"
import style0 from "./ListEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports